import React, { useState } from 'react';
import styles from './Faq.module.scss';

const faqData = [
  {
    q: 'Что можно делать в ФА?',
    a: 'В приложении можно учитывать доходы и расходы, создавать свои категории, смотреть аналитику, ставить финансовые цели и отслеживать прогресс по ним в удобном и понятном интерфейсе.'
  },
  {
    q: 'Чем ФА отличается от обычных таблиц?',
    a: 'В отличие от таблиц, ФА не требует ручной настройки формул, графиков и структуры. Здесь всё уже продумано: от добавления транзакций до аналитики, целей и визуального контроля бюджета.'
  },
  {
    q: 'Нужно ли подключать банковские карты?',
    a: 'Нет. Сейчас все операции добавляются вручную. Это помогает лучше замечать свои траты, осознаннее относиться к деньгам и не терять контроль за движением средств.'
  },
  {
    q: 'Подойдёт ли ФА, если у меня немного операций?',
    a: 'Да. ФА подойдёт и тем, кто только начинает следить за финансами, и тем, кто уже хочет видеть более полную картину по расходам, доходам и целям.'
  },
  {
    q: 'Можно ли пользоваться ФА бесплатно?',
    a: 'Да, основной функционал приложения доступен бесплатно: учёт доходов и расходов, категории, аналитика и финансовые цели.'
  }
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className={styles.faq}>
      <div className={styles.faq__container}>
        <h2 className={styles.faq__title}>Частые вопросы</h2>
        <div className={styles.faq__list}>
          {faqData.map((item, index) => {
            const isActive = activeIndex === index;
            
            return (
              <div key={index} className={`${styles.faqItem} ${isActive ? styles.faqItemActive : ''}`}>
                <button className={styles.faqItem__header} onClick={() => toggleAccordion(index)}>
                  <span className={styles.faqItem__question}>{item.q}</span>
                  <span className={styles.faqItem__icon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                </button>
                <div className={styles.faqItem__contentWrapper}>
                  <div className={styles.faqItem__content}>
                    <p className={styles.faqItem__answer}>{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;